import { Button, Col, Empty, Input, Row, Tabs, Typography, Badge } from 'antd';
import Title from "antd/lib/typography/Title";
import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import { hasCBPermission, hasHRUPermission } from '../../../actions/userSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { isBlank } from "../../../reducers/util";
import {
    createStudy,
    fetchColleagues,
    fetchExampleProjects,
    fetchProjects, fetchSharedProjects, fetchSharedProjectsUnreadCount,
    selectProjects,
    selectSharedProjectsUnreadCount
} from '../cohortBuilderSlice';
import styles from './Projects.module.scss';
import ProjectsList from './ProjectsList';
import {buildStudyPeriodRoute} from "../../../pages/routes";
import buttonStyles from '../../../components/common/styled/Buttons.module.scss'
import {AppDispatch} from "../../../configureStore";
import colors from "../../../style/theme.module.scss";


const { Text } = Typography;
const { TextArea } = Input;

const ShareProjectLabel = ({unreadCount}: {unreadCount: number | undefined}) => {
    return <span>
        Shared Projects
        {unreadCount !== undefined && unreadCount > 0 ?
            <span>&nbsp;
                <Badge
                    color={colors.vantageBlue}
                    count={unreadCount}
                    showZero={false}
                />
            </span>
            : null
        }
    </span>
}

const CreateProject = () => {
    const history = useHistory()
    const dispatch = useAppDispatch()
    const [title, setTitle] = useState<string | undefined>(undefined)
    const [description, setDescription] = useState<string | undefined>(undefined)

    const disabled = isBlank(title) || isBlank(description)

    return <Col span={8}>
        <Title level={3}>Welcome to your cohort builder</Title>
        <Text type="secondary">Create, amend and analyse your patient cohorts of choice.</Text>
        <div>
            <Col>
                <div className={styles.title}>Start a new Project</div>
                <div className={styles.create} data-testid="create-project-box">
                    <div>Project title</div>
                    <Input placeholder="Project title" maxLength={100} value={title} onChange={e => setTitle(e.target.value)} />
                    <br /><br />
                    <div>Project description</div>
                    <TextArea rows={4} maxLength={250} placeholder="Project description" value={description} onChange={e => setDescription(e.target.value)} />
                    <br /><br />
                    <Button className={buttonStyles.primary} type="primary" disabled={disabled} onClick={async () => {
                        const project = await createStudy(title!, description!)
                        await dispatch(fetchProjects())
                        history.push(buildStudyPeriodRoute(project.id))
                    }}>Create</Button>
                </div>
            </Col>
        </div>
    </Col>
}

const loadStudies = (tabNumber: string, dispatch: AppDispatch) => {
    switch (tabNumber) {
        case '1': {
            dispatch(fetchProjects())
            break;
        }
        case '2': {
            dispatch(fetchSharedProjects())
            break;
        }
        case '3': {
            dispatch(fetchExampleProjects())
            break;
        }
        default: {
            break;
        }
    }
}

const ExistingProjects = () => {
    const dispatch = useAppDispatch()
    const userStudies = useAppSelector(selectProjects)
    const sharedProjectsUnreadCount = useAppSelector(selectSharedProjectsUnreadCount)

    useEffect(() => {
        loadStudies('1', dispatch)
        dispatch(fetchSharedProjectsUnreadCount())
    }, [dispatch])

    return <Col span={16}><div>
        <Tabs defaultActiveKey='1' tabBarStyle={{ fontWeight: 'bold' }} onChange={(e) => { loadStudies(e, dispatch) }} >
            <Tabs.TabPane tab="My Projects" key="1">
                <ProjectsList studies={userStudies!} />
            </Tabs.TabPane>
            <Tabs.TabPane tab={<ShareProjectLabel unreadCount={sharedProjectsUnreadCount}/>} key="2">
                <ProjectsList studies={userStudies!} />
            </Tabs.TabPane>
            <Tabs.TabPane tab={<div data-testid="example-projects-tab">Example Projects</div>} key="3" >
                <ProjectsList studies={userStudies!} isExampleProjects />
            </Tabs.TabPane>
        </Tabs>
    </div>
    </Col>
}

const Projects = () => {
    const canCreate = useAppSelector(hasCBPermission)
    const hasHRU = useAppSelector(hasHRUPermission)
    const canView = canCreate || hasHRU

    const create = canCreate ? <CreateProject /> : null
    const projects = canView ? <ExistingProjects /> : <Empty />
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(fetchColleagues())
    }, [dispatch])

    return <div className={styles.studies}>
        <Row>
            {create}
            {projects}
        </Row>
    </div>
}

export default Projects;